import axios from 'axios'
import { isCurrentLocation } from '@/components/auth/authProvider'
import { getStore } from '@/store'
import { actionCreators as identityActions } from '@/store/Identity'
import { replace } from 'react-router-redux'
import { actionCreators as dialogActions } from '@/store/Dialogs'
import { dialogTypes } from '@/dialogs'
import debug from 'debug'

const log = debug('app:fetch')

export const CancelToken = axios.CancelToken

export default function (url, options) {
  return sendRequestSafe(url, options)
}

export function allowErrorDialog (options) {
  if (!options) options = {}
  options.allowErrorDialog = true
  return options
}

export function decomposeError (e) {
  const statusCode = (e && e.response && e.response.status) || 500
  const errorMessage = e && e.response && e.response.data && e.response.data.error && e.response.data.error.message
  return { statusCode, errorMessage }
}

/**
 * Prevents too many requests
 * @param url
 * @param options
 */
const requestHistory = {}
const timespan = 1000
const maxRequestPerTimespan = 5
function sendRequestSafe (url, options) {
  return new Promise((resolve, reject) => {
    let record = requestHistory[url]
    const now = new Date()
    if (!record) {
      record = [now]
      requestHistory[url] = record
    } else {
      record.push(now)
    }
    const olderIndex = record.findIndex(x => now - x < timespan) - 1
    if (olderIndex >= 0) { // remove old records - reduces memory consumption
      record.splice(0, olderIndex)
    }
    const canSendRequest = record.length <= maxRequestPerTimespan
    if (canSendRequest) {
      resolve(sendRequest(url, options))
    } else {
      log('too many requests')
      reject(new Error('too many requests'))
    }
  })
}

function sendRequest (url, options) {
  return axios(url, options)
    .then(response => isFileDownload(response) ? response : response.data)
    .catch(e => {
      const allowErrorDialog = options && options.allowErrorDialog
      const { statusCode, errorMessage } = decomposeError(e)
      if (statusCode === 400) { // validation error / user friendly error
        if (allowErrorDialog && (!e.response.data.error.validationErrors || e.response.data.error.validationErrors.length === 0)) {
          showAlert(errorMessage, errorMessage)
        }
      } else if (statusCode === 401) {
        if (!isCurrentLocation('/login')) {
          getStore().dispatch(identityActions.userSignedOut())
        }
      } else if (statusCode === 403) {
        if (allowErrorDialog) {
          showAlert('Security.PermissionDenied')
        } else {
          e.response.data.error.message = 'Security.PermissionDenied'
        }
      } else if (statusCode === 404 || errorMessage === 'Common:DetailNotFound' || errorMessage === 'Common:RecordNotFound') {
        const url = encodeURIComponent(window.location)
        getStore().dispatch(replace(`/not-found?url=${url}`))
      } else {
        if (allowErrorDialog) showAlert(errorMessage, e.message)
      }
      throw e
    })
}

function showAlert (content, localizedContent) {
  getStore().dispatch(dialogActions.openDialog({
    dialogType: dialogTypes.alert,
    title: 'Common.Error',
    content: content,
    localizedContent: content ? null : localizedContent
  }))
}

function isFileDownload (response) {
  return response && response.headers && response.headers['content-disposition'] &&
    response.headers['content-disposition'].startsWith('attachment;')
}



// WEBPACK FOOTER //
// ./src/utils/fetch.js